// @flow

import React from "react";
import { localize } from "redux-i18n";
import { Button, View } from "@components";
import type { Client as ClientType } from "@modules/client/types";
import detailsUiSchema from "@modules/client/components/client-form/ui-schema";
import benchmarkingUiSchema from "@modules/client/components/client-form/benchmarking-ui-schema";
import DetailsForm from "./details-form";

type OwnProps = $Exact<{
  clientId: number,
  client: ClientType,
  schema: Object,
  disableEdit?: boolean,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export class Organisation extends React.Component<Props> {
  get uiDetailsSchema() {
    return detailsUiSchema(this.props.t);
  }

  get uiBenchmarkingSchema() {
    return benchmarkingUiSchema(this.props.t);
  }

  render() {
    const inTesting = (this.props.client || {}).inTesting || false;
    const disableEdit = this.props.disableEdit || false;
    return (
      <View gap={3}>
        {inTesting === true && (
          <div className="px-5 py-2 record__banner--locked">
            {this.props.t("IN_TESTING_MESSAGE")}
          </div>
        )}
        <DetailsForm
          clientId={this.props.clientId}
          client={this.props.client}
          schema={this.props.schema}
          uiSchema={this.uiDetailsSchema}
          disableEdit={this.props.disableEdit}
        />
        <DetailsForm
          clientId={this.props.clientId}
          client={this.props.client}
          schema={this.props.schema}
          uiSchema={this.uiBenchmarkingSchema}
          disableEdit={this.props.disableEdit}
          isBenchmarking
        />
      </View>
    );
  }
}

export default localize()(Organisation);
